import { ProductsActions } from "../../reducers/products/ActionsNames";

export default function (value: string) {
  return {
    type: ProductsActions.SetDelivery,
    value,
  };
}
